import classNames from 'classnames';
import React from 'react';
import { searchUILabels } from '@components/ui/Search';
import { useCurrentRefinements, UseCurrentRefinementsProps } from 'react-instantsearch-hooks-web';
import './CurrentRefinements.scss';

const formatPriceLabels = (label) => {
  if (label.includes('≥')) {
    return `from $${label.replace('≥', '')}`;
  } else if (label.includes('≤')) {
    return `up to $${label.replace('≤', '')}`;
  }
  return label;
};

const renderLabel = ({ item, refinement }) => {
  switch (item.attribute) {
    case 'price':
      return formatPriceLabels(refinement.label);

    case 'meta.gwm.fits_cup_holder':
      return refinement.label === 'true' ? 'Yes' : 'No';

    default:
      return refinement.label;
  }
};

export const CurrentRefinements = (props) => {
  const { items, refine, canRefine } = useCurrentRefinements(props);
  let wrapperClasses = classNames('ais-CurrentRefinements', props.className, {
    'ais-CurrentRefinements--noRefinement': !canRefine,
  });
  return (
    <div className={wrapperClasses}>
      <ul
        className={classNames('ais-CurrentRefinements-list', {
          'ais-CurrentRefinements-list--noRefinement': !canRefine,
        })}
      >
        {items.map((item) => (
          <li key={item.label} className="ais-CurrentRefinements-item">
            <span className="ais-CurrentRefinements-label">{searchUILabels[item.attribute]?.label}</span>
            {item.refinements.map((refinement) => (
              <span key={refinement.label} className="ais-CurrentRefinements-category">
                <span className="ais-CurrentRefinements-categoryLabel">{renderLabel({ item, refinement })}</span>
                <button
                  onClick={(event) => {
                    event.preventDefault();
                    refine(refinement);
                  }}
                  className="ais-CurrentRefinements-delete"
                >
                  ✕
                </button>
              </span>
            ))}
          </li>
        ))}
      </ul>
    </div>
  );
};
